import { createContext } from "react";
import { ExistingResourceObject } from "../../../../Domains/Products/api/baseTypes.ts";
import { ProductAttributes } from "../../../../Domains/Products/api/productJsonApi.ts";
import { OptionGroupAttributes } from "../../../../Domains/OptionGroups/api/optionGroupsApi.ts";

export type ProductData = PartialRecord<string, ExistingResourceObject<ProductAttributes>>;
export type OptionGroupData = PartialRecord<string, ExistingResourceObject<OptionGroupAttributes>>;

export const ProductOptionGroupDataContext = createContext<{
  productData: ProductData;
  optionGroupData: OptionGroupData;
  setProductData: (productData: ProductData) => void;
  setOptionGroupData: (optionGroupData: OptionGroupData) => void;
}>({
  productData: {},
  optionGroupData: {},
  setProductData: () => {},
  setOptionGroupData: () => {},
});
